import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Avatar, TextField } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom';

function Page1SubPageB() {
    // return <h1>This is Page 5</h1>;
    // state to hold posts fetched from server; intialized to an empty array
    const [posts, setPosts] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const [newPost, setNewPost] = useState('');
    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // run once component loads
    /*useEffect(() => {
        // send GET request to backend to retrieve posts from followed users
        axios.get('/user/following/posts')
            .then(res => setPosts(res.data)) // on success, update "posts" with fetched data
            .catch(err => console.error("Error loading following posts", err));
    }, []);*/
    const fetchPosts = async () => {
        if (loading || !hasMore) return;

        try {
            setLoading(true);

            const res = await axios.get('/user/following/posts', {
                params: { cursor, limit: 10 }
            });

            setPosts(prev => [...prev, ...res.data.posts]);
            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading posts", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    const observer = useRef();

    const lastPostRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchPosts();
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);
    // fxn called when user clicks upvote button
    // postId: MongoDB _id of the post being unvoted
    // sends POST /post/:id/upvote to server
    // receives { upvotes, voted } in response
    // patches React state so UI shows the new count and color
    const toggleVote = async (postId) => {
        try {
             // hit backend endpoint that toggles a vote
             const res = await axios.post(`/post/${postId}/upvote`);

             // update <posts> in react state so ui rerenders
             // setPosts(prev => ...) receives the previous array of posts and must return a new array
             // prev.map( p => { ... } ) 
                // iterate through every post p in old array
                // if p is the one user just voted on, return a new object with the fresh upvote info from server
                // otherwise, return p unchanged
            setPosts((prev) =>
                prev.map((p) =>
                    p._id === postId
                        ? {
                            ...p, // copy exisiting post fields
                            upvotes: res.data.upvotes, // updated count
                            voted:   res.data.voted // true or false that user voted
                        }
                        : p // all other posts unchanged
                )
            );

        } catch(err) {
            console.error("Vote error", err);
        }
    };

    const handleSubmitNewPost = async () => {
        if (!newPost.trim()) return;

        try {
            const res = await axios.post('/user/posts', { content: newPost });

            // Add new post to list
            setPosts(prev => [res.data, ...prev]);

            // Clear input 
            setNewPost('');
        } catch (err) {
            console.error("Error submitting comment", err);
        }
    };


    const handleAddComment = async (postId, commentText) => {
        if (!commentText?.trim()) return;

        try {
        const res = await axios.post(`/post/${postId}/comment`, {
            text: commentText,
        });

        setPosts(prev =>
            prev.map(p =>
            p._id === postId
                ? { ...p, comments: res.data, newComment: '' }
                : p
            )
        );
        } catch (err) {
        console.error("Failed to post comment", err);
        }
    };

    const joinVideoCall = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/video-room`);
            const roomUrl = res.data.url;
            window.open(roomUrl, "_blank"); // open video call in a new tab
        } catch (err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular", path: "/mainsocial/popular" },
      { label: "Following", path: "/mainsocial/following" },
      { label: "Academia", path: "/mainsocial/academia/popular" },
      { label: "Topic Threads", path: "/mainsocial/topicthreads" },
      { label: "Photos", path: "/mainsocial/photos/following" },
      { label: "Videos", path: "/mainsocial/videos/following" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
    // render component UI
    return (
        //<Box p={4}>
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/a')}
                    >
                        Popular
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/b')}
                    >
                        Following
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Ca')}
                    >
                        Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/d')}
                    >
                        Topic Threads
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/followingPhotos')}
                    >
                        Photos
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/followingVideos')}
                    >
                        Videos
                    </Button>
             </Box>*/}
             {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                    
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>

             <Box
                  p={2} // padding inside box
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  sx={{
                      position: "relative",
                      maxWidth: 900, // limit width
                      mx: "auto", // center horizontally
                      my: 2, // vertical spacing between each post
                  }}
              >
              <TextField
                  fullWidth
                  multiline
                  rows={2}
                  placeholder="Pause. Muse — and write..."
                  value={newPost}
                  //value={newComment}
                  //onChange={e => setNewComment(e.target.value)}
                  onChange={(e) => setNewPost(e.target.value)} 
              />
              <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitNewPost}>
                  Submit Post
              </Button>
              </Box>
            {/* following page title */}
            {/*<Typography variant="h4">Following Feed</Typography>*/}

            {/* If there are no posts, show a message */}
            {posts.length === 0 ? (
                <Typography>No posts from followed users.</Typography>
            ) : (
            // if there are posts, loop through each and render it
            posts.map((post, idx) => {
                const isLast = idx === posts.length - 1;

                return (
                <Box
                    key={post._id} // FIX: don't use idx
                    ref={isLast ? lastPostRef : null}
                    //onClick={() => history.push(`/post/${post._id}/comments`)}
                    onClick={() => history.push(`/post/${post._id}/comments`, { source: "following" })}
                    p={2}                // padding inside each post box
                    my={2}               // margin above and below each post box
                    border="1px solid #ccc"  // light border around each post
                    borderRadius="8px"       // rounded corners
                    sx={{
                        position: "relative",
                        maxWidth: 900, // limit width
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
                    /*sx={{ 
                        position: "relative", 
                        maxWidth: 900, // limit width 
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        }}*/
                >
                    {/* Top-right video call button */}
                    {/*<Button
                        onClick={() => joinVideoCall(post._id)}
                        variant="outlined"
                        size="small"
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 1
                        }}
                    >
                        Join Video Call
                    </Button>*/}
                    {/* show username of the post author */}
                    {/*@{post.author?.username || 'Unknown'} */}
                    {/* 
                    <Typography variant="subtitle1" fontWeight="bold">
                        {post.author?.first_name && post.author?.last_name
                            ? `${post.author.first_name} ${post.author.last_name}`
                            : post.author?.username || 'Unknown'}
                    </Typography>
                    */}
                    {/*
                    <Box display="flex" alignItems="center" gap={1}>
                        <Avatar
                            src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                            alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                            sx={{ width: 52, height: 52 }}
                        />
                        <Typography variant="subtitle1" fontWeight="bold">
                            {post.author?.first_name && post.author?.last_name
                                ? `${post.author.first_name} ${post.author.last_name}`
                                : post.author?.username || 'Unknown'}
                        </Typography>
                    </Box>
                    */}
                    {/*<Box display="flex" alignItems="center" gap={1}>*/}
                    {/*<Box display="flex" alignItems="flex-start" gap={1}>
                        <Box>
                        <Avatar
                            src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                            alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                            sx={{ width: 62, height: 62 }}
                        />
                        <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                            {post.author?.first_name && post.author?.last_name
                                ? `${post.author.first_name} ${post.author.last_name}`
                                : 'Unknown Name'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                            @{post.author?.username || 'unknown'}
                            </Typography>
                        </Box>
      
                            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                {post.content}
                            </Typography>

              
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                              
                                {`${new Date(post.created_at).toLocaleString()}, ${post.comments.length} ${post.comments.length === 1 ? 'reply' : 'replies'}`}
                            </Typography>

                        </Box>

                    </Box>*/}
                    <Box display="flex" alignItems="flex-start" gap={1}>
                       <Avatar
                           src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                           alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                           onClick={(e) => visitProfile(e, post.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                       />
                       <Box>
                           <Typography 
                                variant="subtitle1" 
                                fontWeight="bold"
                                onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                {post.author?.first_name && post.author?.last_name
                                    ? `${post.author.first_name} ${post.author.last_name}`
                                    : 'Unknown Name'}
                           </Typography>
                           <Typography 
                                variant="body2" 
                                color="text.secondary"
                                onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                @{post.author?.username || 'unknown'}
                           </Typography>
                           <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                               {post.content}
                           </Typography>
                           {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                               {`${new Date(post.created_at).toLocaleString()}, ${post.comments.length} ${post.comments.length === 1 ? 'reply' : 'replies'}`}
                           </Typography>*/}
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                {`${new Date(post.created_at).toLocaleString()}, ${post.commentCount} ${
                                    post.commentCount === 1 ? 'reply' : 'replies'
                                }`}
                            </Typography>

                       </Box>
                   </Box>

                    {/* show post content */}
                    {/*<Typography>{post.content}</Typography>*/}

                    {/* show formatted creation date below content */}
                    {/*<Typography variant="caption" display="block">
                        {new Date(post.created_at).toLocaleString()}
                    </Typography>*/}

                    {/* Upvote button */}
                    {/*
                    <Box mt={2} display="flex" gap={2}>
                        <Button variant="outlined" size="small">Upvote</Button>
                    </Box>
                    */}
                    {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                        <Button
                            size="small"
                            variant={post.voted ? "contained" : "outlined"}
                            //onClick={() => toggleVote(post._id)}
                            onClick={(e) => {
                                e.stopPropagation(); 
                                toggleVote(post._id)}
                            }
                        >
                            ▲ {post.voted ? "Unvote" : "Power Vote"}
                        </Button>
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                    </Box>*/}
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>
            


                    {/* Add comment input */}
                    {/*
                    <Box mt={2}>
                        <input
                            type="text"
                            placeholder="Add a comment"
                            value={post.newComment || ''}
                            onChange={(e) =>
                            setPosts(prev =>
                                prev.map(p =>
                                p._id === post._id ? { ...p, newComment: e.target.value } : p
                                )
                            )
                            }
                            style={{ width: "100%", padding: "6px", marginBottom: "8px" }}
                        />
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleAddComment(post._id, post.newComment)}
                        >
                            Submit Comment
                        </Button>
                    </Box>
                    */}

                    {/* View Comments Button */}
                    {/*<Button
                        variant="outlined"
                        size="small"
                        onClick={() => history.push(`/post/${post._id}/comments`)}
                        sx={{ mt: 1 }}
                        >
                        View Comments
                    </Button>*/}
                </Box>
                
            );})
        )}        
    
        {/*</Box>*/}
        </div>
    );
}

export default Page1SubPageB;